import { Outlet } from "react-router-dom";
import CustomPageWrapper from "./components/CustomPageWrapper";
import ConfirmActionDialog from "./components/site/ConfirmActionDialog";

const Layout = () => {
  return (
    <CustomPageWrapper>
      <ConfirmActionDialog />
      <Outlet />
    </CustomPageWrapper>
  );
};

export default Layout;
